import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-100 w-sm-90 w-xs-90 mt-10 mt-lg-15 mx-lg-auto mx-sm-auto mx-xs-auto" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body w-50 mx-auto" }
const _hoisted_4 = { class: "text-center text-success" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-check-circle",
    style: {"font-size":"4em"}
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Payment Successful!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("p", null, " Please wait (" + _toDisplayString(_ctx.timer) + " seconds) while you are being redirected... ", 1)
        ])
      ])
    ])
  ]))
}